import { BreakpointStates } from '../../../modules/Responsive/Responsive.types';
import { LOGO_SIZES } from './constants';

export const getLogoSize = (breakpoints: BreakpointStates) => {
  if (breakpoints.tablet || breakpoints.desktopNarrow || breakpoints.mobileLayout) {
    return LOGO_SIZES.tablet;
  }

  if (breakpoints.desktop) {
    return LOGO_SIZES.desktop;
  }

  if (breakpoints.wide) {
    return LOGO_SIZES.wide;
  }

  return LOGO_SIZES.mobile;
};
